<template>
  <div id="property-management" class="flex flex-wrap-reverse items-center data-list-btn-container">
    <vs-table ref="table" multiple v-model="selected" :max-items="itemsPerPage" search :data="onboardingsData">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ onboardingsData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : onboardingsData.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th sort-key="code">Restaurant</vs-th>
        <vs-th sort-key="code">Full Name</vs-th>
        <vs-th sort-key="name">Url</vs-th>
        <vs-th sort-key="name">Email</vs-th>
        <vs-th>Action</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.restaurant.user_property["Restaurant-Name"] }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.legal_name }} {{ tr.legal_last_name }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.business_website }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.email_address }}</p>
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="viewData(tr.id)" />
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>

  </div>

</template>

<script>

import vSelect from 'vue-select'
import {mapActions} from 'vuex'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      onboardingsData: [],
      onboardingId: null,
      selected: [],
      // products: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.onboardingsData.length
    }
  },
  mounted () {
    this.getOnboardingData()
  },
  methods: {
    ...mapActions('onBoarding', ['getOnboardings', 'fetchOnboarding']),
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    async getOnboardingData () {
      this.$vs.loading()
      const onboardings = await this.getOnboardings()
      if (onboardings.status) {
        this.onboardingsData = onboardings.data
      } else {
        this.openNotify({title: 'Error', icon: 'icon-alert-circle', text: onboardings.message, color: 'danger' })
      }
      this.$vs.loading.close()
    },
    viewData (formId) {
      this.$vs.loading()
      this.$router.push({name: 'onboarding-form-detail', params: {formId }}).catch(() => {})
      this.$vs.loading.close()
    }
  }
}

</script>

<style lang="scss">
#property-management{
  .vs--single.vs--open .vs__selected{
    position: initial;
  }
  .vs-table-primary{
    width:100%;
  }
}
</style>
